import axios from "axios";
import { Notification } from "src/types/settings/notifications";

const BASE_URL = process.env.REACT_APP_USERS_API_URL;
const notificationsApiUrl = `${BASE_URL}/users/3.0/preferences/notifications`;

export const notificationsApi = {

  fetchNotification: async (): Promise<Notification> => {
    const response = await axios.get(notificationsApiUrl);
    return response.data;
  },

  updateNotification: async (data): Promise<Notification> => {
    const response = await axios.put(
      `${notificationsApiUrl}`,
      data,
    );
    return response.data;
  },

};
